'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useBreadcrumb } from '@/contexts/app-context';
import { NAV_ITEMS } from '@/components/nav/nav-main';
import { useTranslations } from 'next-intl';

type BreadcrumbItem = {
  label: string;
  href?: string;
  isCurrentPage?: boolean;
};

export function useDynamicBreadcrumbs() {
  const pathname = usePathname();
  const { setBreadcrumbs } = useBreadcrumb();
  const t = useTranslations('Navigation');

  useEffect(() => {
    const pathSegments = pathname.split('/').filter(Boolean);
    const breadcrumbItems: BreadcrumbItem[] = [];

    // Other pages - find the main navigation item
    const currentPath = `/${pathSegments[0]}`;
    const navItem = NAV_ITEMS.find((item) => item.url === currentPath);

    if (navItem) {
      breadcrumbItems.push({
        label: t(navItem.titleKey),
        href: navItem.url,
        isCurrentPage: pathSegments.length === 1,
      });
    }

    setBreadcrumbs(breadcrumbItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
}
